import { GetExperienceResponseBodyType } from "@intelligems/ig-types";
import { useQueries } from "@tanstack/react-query";

import { QueryOptions } from "../../types/react-query";
import { experienceKeys } from "../queryKeys";

import { getExperience } from "./get-experience";

export const useGetExperiences = (
  experienceIds: string[],
  options?: QueryOptions<GetExperienceResponseBodyType, Error>
) => {
  return useQueries({
    queries: experienceIds.map((experienceId) => ({
      ...options,
      queryKey: experienceKeys.one(experienceId),
      queryFn: async () => getExperience(experienceId),
      enabled: Boolean(experienceId),
    })),
  });
};
